import { useState } from 'react';
import { getRideAdditionalServices } from '../../../services/customer/ticketBookingServices';

function UseAdditionalServices({
  id, carriageId, passengerAgeRangeId, seatClassId, seatNumber, statementSeatId, setServices,
}) {
  const [additionalServices, setAdditionalServices] = useState([]);

  const fetchServices = async () => {
    const res = await getRideAdditionalServices(id, {
      carriageId, passengerAgeRangeId, seatClassId, seatNumber, statementSeatId,
    });
    setAdditionalServices(res);
    setServices((prev) => {
      if (Array.isArray(prev)) {
        return [...prev, ...res];
      }
      return prev;
    });
  };

  return { additionalServices, fetchServices };
}

export default UseAdditionalServices;
